import { SectionInterface, NotifySubscriberPayloadInterface } from '@/types/interfaces';
import * as enums from '@/types/enums';
import * as constants from '@/types/constants';
import {Promise} from 'bluebird';
import Vue from 'vue';
import getMailDataForNotification from '../../services/getMailDataForNotification';

const vueAppData = process.env.VUE_APP_DATA;
const moduleDecorators = require(`../../decorators/${vueAppData}Decorators/${vueAppData}ModuleDecorators`).default;

export const sectionsModule = {
  moduleName: 'sectionsModule',
  statePropName: 'data',
  namespaced: true, // automatically added
  // you can also add your own state/getters/mutations/actions
  serverChange: {
    convertTimestamps: {
      createdAt: '%convertTimestamp%',
      acceptedAt: '%convertTimestamp%',
      deadline: '%convertTimestamp%',
    },
    addedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    },
    modifiedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    },
    removedHook(updateStore, doc, id, store) {
      return updateStore(doc);
    }
  },
  sync: {
    preventInitialDocInsertion: true,
    where: [],
    orderBy: [],
    fillables: [],
    guard: [],
    defaultValues: {},
    debounceTimerMs: 1000,
    // HOOKS for local changes:
    insertHook(updateStore, doc, store) {
      return updateStore(doc);
    },
    patchHook(updateStore, doc, store) {
      return updateStore(doc);
    },
    deleteHook(updateStore, id, store) {
      return updateStore(id);
    },
    // for batches
    insertBatchHook(updateStore, docs, store) {
      return updateStore(docs);
    },
    patchBatchHook(updateStore, doc, ids, store) {
      return updateStore(doc, ids);
    },
    deleteBatchHook(updateStore, ids, store) {
      return updateStore(ids);
    }
  },
  state: {
    isApprovedSections: false,
    initialParentId: '0',
    size: {},
    isDbChannelIsOpen: false,
    fetchedSize: {},
  },
  getters: {
    data: state => state.data,
    allSections: state => state.data,
    initialParentId: state => state.initialParentId,
    sizeByStatus: state => status => state.size[status],
    sectionByIdDocumentAndByStatus: (state, getters, rootGetters) => {
      const data = state.data;
      return (statusOne, StatusTwo) => {
       let result = Object.keys(data)
          .filter(
              key => data[key].status === statusOne || data[key].status === StatusTwo
          )
          .map(id => data[id])
          .filter(section => section !== undefined)
          .filter(key => data[key] === rootGetters["mainModule/prettyLink"])

        const seen = new Set();
        return result.filter(el => {
          const duplicate = seen.has(el.topic);
          seen.add(el.topic);
          return !duplicate;
        });
      }
    },
    sectionsByStatus: (state, getters) => {
      return (status, sectionId?) => {
        console.log('Sections By Status=' + status + " sectionId=" + sectionId);
        status = parseInt(status);
        const sectionsArray =
          status === enums.SECTION_STATUS.toEdit || status === enums.SECTION_STATUS.edited
            ? getters["sectionById"](sectionId)[0]
            ? new Array(getters["sectionById"](sectionId)[0])
            : []
            : [];
        const data = state.data;
        let ans = Object.keys(data)
            .filter(key => data[key].status === status)
            .filter(key =>
                sectionId ? data[key].parentSectionId === sectionId : true
            )
            .map(id => data[id])
            .filter(section => section !== undefined)
            .concat(sectionsArray)
            .sort((sectionA: SectionInterface, sectionB: SectionInterface) =>
                status === enums.SECTION_STATUS.edited
                    ? new Date(sectionB.acceptedAt!).getTime() -
                    new Date(sectionA.acceptedAt!).getTime()
                    : status === enums.SECTION_STATUS.approved
                    ? new Date(sectionA.createdAt).getTime() -
                    new Date(sectionB.createdAt).getTime()
                    : new Date(sectionB.createdAt).getTime() -
                    new Date(sectionA.createdAt).getTime()
            );
        console.log('Filtered Sections', ans); // JSON.stringify(ans.map(x => x.id))
        return ans;
      };
    },
    sectionsByEdit: (state, getters) => {
      console.log('Sections By Edit');
      return (status, sectionId?) => {
        status = parseInt(status);
        const sectionsArray =
            status === enums.SECTION_STATUS.toEdit
                ? getters["sectionById"](sectionId)[0]
                ? new Array(getters["sectionById"](sectionId)[0])
                : []
                : [];
        const data = state.data;
        let filteredArray = Object.keys(data)
            .filter(key => [enums.SECTION_STATUS.inTheVote, enums.SECTION_STATUS.approved, enums.SECTION_STATUS.toEdit, enums.SECTION_STATUS.toEditInTheVote].includes(data[key].status))
            .filter(key =>
                sectionId ? data[key].parentSectionId === sectionId : false
            )
            .map(id => data[id])
            .filter(section => section !== undefined)
            .concat(sectionsArray)
            .sort((sectionA: SectionInterface, sectionB: SectionInterface) =>
                status === enums.SECTION_STATUS.edited
                    ? new Date(sectionB.acceptedAt!).getTime() -
                    new Date(sectionA.acceptedAt!).getTime()
                    : status === enums.SECTION_STATUS.approved
                    ? new Date(sectionA.createdAt).getTime() -
                    new Date(sectionB.createdAt).getTime()
                    : new Date(sectionB.createdAt).getTime() -
                    new Date(sectionA.createdAt).getTime()
            );
        console.log("Filtered Sections by status=" + status + " sectionId=" + sectionId + ": ", filteredArray);
        return filteredArray;
      };
    },
    sectionsByTopics: (state) => {
      // const sectionsStatuses = [enums.SECTION_STATUS.inTheVote, enums.SECTION_STATUS.approved]
      return (topics) => {
        const data = state.data;
        let filteredArray = Object.keys(data)
            .filter(key => topics.includes(data[key].topic))
            .map(id => data[id])
            .filter(section => section !== undefined);
        console.log("Filtered Sections by " + JSON.stringify(topics) + " Topics: ", filteredArray);
        return filteredArray;
      };
    },
    sectionsByTopicsAndStatuses: (state) => {
      return (topics, statuses) => {
        const data = state.data;
        let filteredArray = Object.keys(data)
            .filter(key => topics.includes(data[key].topic) && (statuses.includes(data[key].status)))
            .map(id => data[id])
            .filter(section => section !== undefined);
        console.log("Filtered Sections by " + JSON.stringify(topics) + " topics and " + JSON.stringify(statuses) + " statuses: ", filteredArray);
        return filteredArray;
      };
    },
    sectionById: state => id => [state.data[id]],
    isSectionsInRevisions: state => status =>
      Object.values(constants.STATIC_PAGES).includes(status),
    isStaticFeed: state => (PageStatus: number) =>
      Object.values(enums.STATIC_STATUS).includes(PageStatus),
    isDynamicFeed: state => (PageStatus: number) =>
      Object.values(enums.DYNAMIC_STATUS).includes(PageStatus),
    sectionIndex: (state, getters) => (status, parentSectionId, sectionId) =>
      getters["sectionsByStatus"](status, parentSectionId)
        .map(section => section.id)
        .indexOf(sectionId) + 1,
    isParentSection: (state, getters) => sectionId =>
      sectionId === state.initialParentId ||
      getters["sectionById"](sectionId)[0].status ===
      enums.SECTION_STATUS.approved,
    getDeadline: state => deadline => {
      let time = deadline;
      if (time.getSeconds()) {
        time = new Date(time.getSeconds() * 1000);
      } // Epoch
      const countDownDate = new Date(time).getTime();
      return countDownDate - new Date().getTime();
    },
    sectionRejectedLength: state =>
      Object.keys(state.data).filter(
        key => state.data[key].status === enums.SECTION_STATUS.rejected
      ).length,
    isReachedDeadline: (state, getters) => deadline =>
      getters.getDeadline(deadline) < 0,
    sectionsIdsByParentId: (state) => (parentSectionId) => {
      return Object.keys(state.data).filter(sectionId => state.data[sectionId].parentSectionId === parentSectionId)
    }
  },
  mutations: {
    setToSectionById: (state, {id, payload}) => {
      Object.keys(state.data).forEach((key, index) => {
        if (key === id) {
          Vue.set(state.data[id], index, payload);
        }
      });
    },
    setToSize: (state, {status, size}) => {
      Vue.set(state.size, status, size);
    },
    fetchedSize: (state, {status}) => {
      Vue.set(state.fetchedSize, status, true);
    },
    setIsDbChannelIsOpen: state => {
      Vue.set(state, 'isDbChannelIsOpen', true);
    }
  },
  actions: {
    /**
     * getting section by id
     */
    getSectionById: async (
      {state, getters, dispatch, rootGetters, commit},
      {sectionId, action}: { sectionId: string; action: string }
    ) => {
      if (state.data[sectionId] !== undefined) {
        return getters["sectionById"](sectionId)[0];
      } else {
        const where = [
          ["documentId", "==", rootGetters["mainModule/prettyLink"]],
          ["id", "==", sectionId]
        ];
        await dispatch(action, {where});
        commit('setIsDbChannelIsOpen');

        return getters['sectionById'](sectionId)[0];
      }
    },
    /**
     * adding section
     * @param payload
     */
    addSection: async ({rootGetters, dispatch}, payload) => {
      console.log('sectionsModule.addSection() Add Section ' + JSON.stringify(payload));
      const deadline = new Date();
      let timer = rootGetters['documentsModule/documentTimer'];
      if (timer == null) {
        timer = 1000;
      }
      const hours = deadline.getHours() + timer;
      deadline.setHours(hours);
      let documentId = rootGetters['documentsModule/documentId'];
      const userUid = rootGetters['usersModule/userUid'];
      const newSection = {
        ...payload,
        cons: [],
        createdAt: new Date(),
        deadline,
        documentId: documentId,
        owner: userUid,
        pros: [userUid],
        timer: timer
      };
      const documentThreshold = rootGetters['documentsModule/documentThreshold'];
      if (documentThreshold) {
        newSection.threshold = documentThreshold;
      }
      console.log('Dispatch insert newSection ' + JSON.stringify(newSection));
      const newSectionId = await dispatch('insert', newSection);
      const update = {id: newSectionId, updateObject: {id: newSectionId}};
      console.log('Dispatch updateSection update ' + JSON.stringify(update));
      await dispatch('updateSection', update);
      console.log('Return newSectionId ' + JSON.stringify(newSectionId));

      let isNewSection: boolean;
      if (payload.parentSectionId === '0') {
        console.log('New Section Created: ', newSectionId);
        isNewSection = true;
      } else {
        console.log('Edit Section Created: ', newSectionId, 'Parent is: ', payload.parentSectionId);
        isNewSection = false;
      }

      // subscribe user for section notifications
      dispatch('usersModule/subscribeToSectionNotifications', {
        sectionId: newSectionId,
        value: true
      }, { root: true });

      // subscribe also for the parent section in case of edit suggestion
      if (!isNewSection) {
        dispatch('usersModule/subscribeToSectionNotifications', {
          sectionId: payload.parentSectionId,
          value: true
        }, { root: true });
      }

      const parentSectionContent = isNewSection ? undefined : rootGetters['sectionsModule/sectionById'](payload.parentSectionId)[0].content;
      const trigger = isNewSection ? enums.NOTIFICATION_TRIGGER.sectionCreation : enums.NOTIFICATION_TRIGGER.sectionEdit
      const sectionId = isNewSection ? newSectionId : payload.parentSectionId

      const { body, title } = await getMailDataForNotification({
        documentId,
        documentTitle: rootGetters['documentsModule/documentTitle'],
        sectionId,
        sectionOrArgumentContent: payload.content,
        userName: rootGetters['usersModule/displayName'],
        parentSectionContent,
        trigger,
        newSectionId: isNewSection ? undefined : newSectionId
      });

      const notificationPayload: NotifySubscriberPayloadInterface = {
        documentId,
        sectionId,
        trigger,
        sectionOrArgumentContent: payload.content,
        body,
        title
      };
      dispatch('notificationsModule/notifySubscribers', notificationPayload, { root: true });

      const newChangeEvent = {
        createdAt: new Date(),
        type: payload.acceptedByEditor ? 'Editor/Admin User Edit a Section' : ('User Added New ' + (newSection.parentSectionId != '0' ? 'Edit ' : '') + 'Section Suggestion'),
        subType: null,
        itemId: newSectionId,
        parentItemId: payload.parentSectionId,
        documentId,
        creator: rootGetters['usersModule/userUid'],
        content: { title, body }
      };
      await dispatch('changeEventsModule/addChangeEvent', newChangeEvent, { root: true });
      return newSectionId;
    },
    /**
     * updates the section
     * @param {string} id the id of the section
     * @param {object} updateObject the keys and values to update
     */
    updateSection: async ({dispatch}, {id, updateObject}) => {
      dispatch('patch', {id, updateObject});
    },
    /**
     * updates the parent section of the section
     * @param {string} parentSectionId the parent section id
     * @param {string} sectionId the section id
     * @param {number} newStatus the new status of the section
     * @param {number} prevStatus the previous status of the section
     *
     */
    updateParentSection: async (
      {state, dispatch},
      {parentSectionId, sectionId, newStatus, prevStatus, acceptedByEditor}
    ) => {
      const parentSection = state.data[parentSectionId];
      const currentSection = state.data[sectionId];
      let newStatusName = Object.keys(enums.SECTION_STATUS)[newStatus];
      if (newStatusName === 'toEditInTheVote') { newStatusName = 'toEdit'}
      const prevStatusName = Object.keys(enums.SECTION_STATUS)[prevStatus];
      /**
       * filer the sectionId from previous status array and add it to new status array
       */
      if (!parentSection) return;
      let updateObject: any = {};
      if (parentSection[newStatusName]) {
        updateObject = {
          [newStatusName]: (parentSection[newStatusName]).concat(sectionId)
        };
      }
      if (prevStatus && prevStatus !== enums.SECTION_STATUS.approved) {
        updateObject = {
          ...updateObject,
          [prevStatusName]: parentSection[prevStatusName].filter(
            id => id !== sectionId
          )
        };
      }
      if (newStatus === enums.SECTION_STATUS.deleted) {
        updateObject = {
          ...updateObject,
          status: newStatus
        };
      }
      if (newStatus === enums.SECTION_STATUS.edited) {
        updateObject = {
          ...updateObject,
          createdAt: currentSection.createdAt,
          acceptedAt: new Date(),
          ...(await dispatch("replaceProperties", {
            sectionId,
            parentSectionId
          }))
        };
      }
      console.log(
        "updating the parent section -> it gets the created and accepted of the EDITED section:",
        parentSectionId,
        {...updateObject}
      );
      if (acceptedByEditor !== null) {
        updateObject = {...updateObject, acceptedByEditor};
      }
      await dispatch('updateSection', {
        id: parentSectionId,
        updateObject: {...updateObject}
      });
    },
    /**
     * updates the threshold of the sections that has one of this statuses: inTheVote, toDelete, toEdit
     * @param {number} threshold
     */
    updateThreshold: ({state, getters, dispatch}, {threshold}) => {
      const sections = [
        enums.SECTION_STATUS.inTheVote,
        enums.SECTION_STATUS.toDelete,
        enums.SECTION_STATUS.toEdit
      ].map(status =>
        Object.keys(state.data).filter(key => state.data[key].status === status)
      );
      return Promise.map(sections.flat(), async section => {
        await dispatch('updateSection', {
          id: section,
          updateObject: {threshold}
        });
      });
    },
    /**
     * replace properties between the approved section - the parent section and the edited section.
     * The parent section getting the content of the edited section
     * @param {string} parentSectionId the parent section id
     * @param {string} sectionId the section id
     * */
    replaceProperties: async (
      {getters, dispatch},
      {sectionId, parentSectionId}
    ) => {
      const keys = [
        "content",
        "contentHtml",
        "owner",
        "cons",
        "pros",
        "threshold",
        "timer",
        "deadline",
        "acceptedByEditor"
      ];
      const newSection = getters['sectionById'](sectionId)[0];
      const parentSection = getters['sectionById'](parentSectionId)[0];
      let updateApprovedSection = {};
      keys.forEach(key => {
        updateApprovedSection = {
          ...updateApprovedSection,
          [key]: newSection[key] ? newSection[key] : null
        };
      });
      let updateEditedSection = {};
      keys.forEach(key => {
        updateEditedSection = {
          ...updateEditedSection,
          [key]: parentSection[key] ? parentSection[key] : null
        };
      });
      console.log('updating the section:', sectionId, {
        ...updateEditedSection,
        acceptedAt: parentSection.acceptedAt,
        createdAt: parentSection.createdAt,
      });
      await dispatch('updateSection', {
        id: sectionId,
        updateObject: {
          ...updateEditedSection,
          acceptedAt: parentSection.acceptedAt,
          createdAt: parentSection.createdAt
        }
      });
      dispatch(
        "argumentsModule/updateArgumentSectionIds",
        {oldId: sectionId, newId: parentSectionId},
        {root: true}
      );
      return updateApprovedSection;
    },
    /**
     * updates the status of the section if the deadline of the section is over
     */
    updateStatusByDeadline: async ({state, getters, dispatch}) => {
      Object.keys(getters.data).forEach(async sectionId => {
        const time = getters.data[sectionId].deadline;
        if (
          Object.values(enums.DYNAMIC_STATUS).includes(
            getters.data[sectionId].status
          ) &&
          getters.isReachedDeadline(time)
        ) {
          await dispatch('updateSection', {
            id: sectionId,
            updateObject: {status: enums.SECTION_STATUS.rejected}
          });
        }
      });
    },
    deleteSection: async ({dispatch}, {id}) => {
      await  dispatch('delete', id);
    }
  }
};
console.log('Decorate Section Module');
moduleDecorators['sectionsModuleDecorator'](sectionsModule);
